// TODO: UPI_P2P_V2 перенести в @martixtech/contracts и вернуть реэкспорт оттуда
export enum PAYMENT_PAGE_TYPE {
    DEFAULT = 'DEFAULT',
    UPI_P2P = 'UPI_P2P',
    UPI_P2P_V2 = 'UPI_P2P_V2',
    UPI_INTENT_QR = 'UPI_INTENT_QR',
}

export const INSTANCE_PATH = 'payment_methods';

export enum RESPONSE_ERROR {
    DUPLICATED_ID = 'DUPLICATED_ID',
    DUPLICATED_NAME = 'DUPLICATED_NAME',
}

export enum PAYMENT_METHOD_TYPE {
    PAY_IN = 'PAY_IN',
    PAY_OUT = 'PAY_OUT',
}

export enum PAYMENT_METHOD_MODE_GROUP {
    MANUAL = 'MANUAL',
    BKASH = 'BKASH',
    UPI = 'UPI',
    NAGAD = 'NAGAD',
    ASU = 'ASU',

    IMPS_PAYOUT = 'IMPS_PAYOUT',
    BKASH_PAYOUT = 'BKASH_PAYOUT',
}

export enum PAYMENT_METHOD_ALIAS {
    UPI = 'UPI',
    BKASH = 'BKASH',
    ROCKET = 'ROCKET',
    NAGAD = 'NAGAD',
    IMPS = 'IMPS',
    UPI_INTENT = 'UPI_INTENT',
    TEST = 'TEST',
    M10 = 'M10',
    VISA = 'VISA',
    PAYOUT = 'PAYOUT',
    BKASH_API = 'BKASH_API',
    NAGAD_API = 'NAGAD_API',
}

export enum PAYMENT_METHOD_TIMEZONE {
    UTC = 'UTC',
    IST = 'IST',
    BST = 'BST',
}

export enum CLIENT_FIELD_TYPE {
    STRING = 'STRING',
    NUMBER = 'NUMBER',
    REGEX = 'REGEX',
    DATETIME = 'DATETIME',
}
